import NothingToShow from "assets/icons/NothingToShow";
import { t } from "i18next";

export default function PersonalAINotFound({
  message = t("recommendationNotFoundMessage"),
}) {
  return (
    <div className="w-full flex items-center justify-center flex-col gap-4 my-10">
      <NothingToShow className="max-w-[140px]" />
      <h2 className="text-3xl font-heebo font-bold text-[#595959]">
        {t("recommendationNotFoundTitle")}
      </h2>
      <p className="text-[#595959] font-light max-w-[220px] text-center">
        {message}
      </p>
    </div>
  );
}
